import { Card } from 'react-bootstrap';

/**
 * Comprovante do agendamento: horário em destaque, profissional, local, cliente (opcional),
 * serviços e total. É o mesmo cartão na revisão (antes de confirmar) e na tela de sucesso
 * (depois), para o cliente reconhecer o que conferiu.
 *
 * @param {string} time - Horário ("14:00").
 * @param {string} dateLabel - Data por extenso, já formatada.
 * @param {object} professional - { name, photoUrl, isRandom }: foto sobre a inicial do nome.
 * @param {object} place - { name, address }.
 * @param {object} customer - { name, phone }; omitido, a linha do cliente não aparece.
 * @param {Array} services - [{ key, name, duration, priceNode }], com o preço já desenhado.
 * @param {object} total - { durationLabel, node }: duração somada e o valor (ou carregamento).
 */
const AppointmentTicket = ({ time, dateLabel, professional, place, customer, services, total, serviceLabel }) => (
    <Card className="confirmation-ticket mb-4">
        <div className="confirmation-ticket__when">
            <span className="confirmation-ticket__time">{time}</span>
            <span className="confirmation-ticket__date">{dateLabel}</span>
        </div>

        <div className="confirmation-ticket__rows">
            <div className="confirmation-ticket__row">
                <span className="confirmation-ticket__avatar" aria-hidden="true">
                    {professional.isRandom ? <i className="fa fa-shuffle"></i> : (
                        <>
                            {(professional.name || '?').charAt(0).toUpperCase()}
                            <img src={professional.photoUrl} alt=""
                                onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                        </>
                    )}
                </span>
                <div>
                    <small>Profissional</small>
                    <strong>{professional.name}</strong>
                </div>
            </div>

            <div className="confirmation-ticket__row">
                <span className="confirmation-ticket__icon" aria-hidden="true"><i className="fa fa-location-dot"></i></span>
                <div>
                    <small>Filial</small>
                    <strong>{place.name}</strong>
                    {place.address && <span>{place.address}</span>}
                </div>
            </div>

            {customer && (
                <div className="confirmation-ticket__row">
                    <span className="confirmation-ticket__icon" aria-hidden="true"><i className="fa fa-user"></i></span>
                    <div>
                        <small>Cliente</small>
                        <strong>{customer.name}</strong>
                        {customer.phone && <span>{customer.phone}</span>}
                    </div>
                </div>
            )}
        </div>

        <div className="confirmation-ticket__services">
            <small className="confirmation-ticket__label">{services.length} {serviceLabel}</small>
            {services.map((service) => (
                <div key={service.key} className="confirmation-ticket__service">
                    <div>
                        <strong>{service.name}</strong>
                        <span>{service.duration} min</span>
                    </div>
                    <div className="confirmation-ticket__price">{service.priceNode}</div>
                </div>
            ))}
        </div>

        <div className="confirmation-ticket__total">
            <div>
                <strong>Total</strong>
                <span>{total.durationLabel}</span>
            </div>
            <strong className="confirmation-ticket__total-value">{total.node}</strong>
        </div>
    </Card>
);

export default AppointmentTicket;
